export default "__VITE_ASSET__DRzFUcZ9__"